import React, {useState, useRef, useEffect} from "react";
import PropTypes from "prop-types";
import StyledDropDown from "./DropDown.styled";
import DropDownRadio from "./DropDownRadio";
import {FaChevronDown} from "react-icons/fa";
import useOutsideClick from "../../../helpers/useOutsideClick";

const productPriceRange= [
  {
    id: 1,
    value: "unit_price|desc",
    type: "radio",
    name: "Highest price"
  },{
    id: 2,
    value: "unit_price|asc",
    type: "radio",
    name: "Lowest price"
  },{
    id: 3,
    value: "orders_count|desc",
    type: "radio",
    name: "Best sellers"
  },
]

const DropDownSortBy = React.memo(props => {
  const {
    parsed,
    className,
    name,
    onChange,
    setSortBy,
    toggleNavMenu,
    sortByOpen,
    setSortByOpen,
    showMenu,
    setShowMenu,
    datatestid,
  } = props;
  const ref = useRef();
  const [sortedBy, setSortedBy] = useState('')
  useOutsideClick(ref, () => {
    if (showMenu) setShowMenu(false); setSortByOpen(false);
  });
  useEffect(()=>{
    let sortBy = productPriceRange.filter(item=> parsed.order_by === item.value)
    if(sortBy.length){
      setSortedBy(sortBy[0].name)
    } else {
      setSortedBy('Sort by')
    }
  }, [parsed])

  const getId =(e)=>{
    (productPriceRange.find(item => item.id === e.target.id? (setSortBy(item.name)):''))
  }
  

  return (
    <StyledDropDown ref={ref} className={className} data-testid={datatestid}>
      {/* eslint-disable-next-line no-sequences */}
        <button onClick={()=>{ toggleNavMenu(); setShowMenu(!showMenu)}} className="dropdown-sort__button" >
          <span className="dropdown-sort__title" >{ sortedBy }</span>
          <FaChevronDown  className={`dropdown-sort__icon ${sortByOpen? "isOpen":"isClosed"}`}/>
        </button>

        <ul className={`dropdown-sort__menu ${showMenu ? '' : 't-hidden'}`}>
          {productPriceRange.map((item) => (
            <li  key={item.id}>
              <DropDownRadio
                range={item}
                checked={parsed.order_by === item.value}
                value={item.value}
                onChange={onChange}
                name={name}
                getId={getId}
              />
            </li>
          ))}
        </ul>
    </StyledDropDown>
  );
});

DropDownSortBy.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  priceRange: PropTypes.array,
  sendPrice: PropTypes.func,
  setSortBy: PropTypes.func
};

export default DropDownSortBy;